<script>
  import { page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let text;
  export let author;
  let grow = false;
</script>

<section class="quote-wrap">
  <div
    class="container"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <img
      class="quote__img"
      src={`${$page.props.asset_url}img/quote.svg`}
      width="70"
      height="51"
      alt="Quote"
    />
    <figure class="quote text-center">
      <blockquote class="h5">{@html text}</blockquote>

      <figcaption class="quote__author">
        <span class="text-siganture">{author.signature}</span>
        <span class="quote__author-name text-small">{author.full_name}</span>
        <span class="quote__author-position text-small">{author.position}</span>
      </figcaption>
    </figure>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .quote {
    @include resp-min('s') {
      margin: 3rem 0 0;
    }

    @include resp-max('s') {
      padding: 0 3rem;
      margin: 0;
    }

    &__img {
      margin: 0 auto;

      @include resp-max('s') {
        display: none;
      }
    }

    &__author {
      margin: 2rem 0 0;

      span {
        display: block;
      }

      &-name {
        margin: 1rem 0 0;
      }

      &-position {
        opacity: 0.5;
      }
    }
  }

  .quote-wrap {
    @include resp-max('s') {
      border-top: 1px solid $light-border;
      border-bottom: 1px solid $light-border;
    }
    .container {
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }
    }
  }
</style>
